
/*
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-27 17:53:06
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-05-22 00:12:21
 * @FilePath:
 * @Description: 排队相关api
 */
import { requestOfPut,requestOfPost, requestOfGet } from "../utils/http"
const baseUrl = 'wechath5/zh-cn/v1/checkin'



export function getQueueHistory(param) {
  return requestOfPost(`${baseUrl}/WXQueuingUpManagementQuery`, param)
}
export function takeQueueNumber(param) {
  return requestOfPost(`${baseUrl}/QueuingUpSave`, param)
}
export function changeQueueNumberStatus(param) {
  return requestOfPost(`${baseUrl}/QueuingUpStateChange`, param)
}
export function getQueueNumberDetail(param) {
  return requestOfPost(`${baseUrl}/WXQueuingUpManagementDetail`, param)
}
export function bindQueueNumberByPad(param) {
  return requestOfPost(`${baseUrl}/QueuingUpStateChangeBind`, param)
}


